import React, { FC } from 'react';

interface Props {
  number: number;
}

const NumberBox: FC<Props> = ({ number }) => {
  return (
    <div className="font-subtitle3 rounded-5 text-gray-lighter bg-primary-main w-32 h-32 flex items-center justify-center">
      {number}
    </div>
  );
};

export default NumberBox;
